<template>
    <div class="bg-white-gray rounded-[4px] w-[26px] h-[26px] font-dm-sans-500 font-medium text-[14px] flex items-center justify-center cursor-pointer"
    :class="allow ? 'text-gray-dark' : 'text-extra-text-color'">
        <slot />
    </div>
</template>

<script lang="ts" setup>
defineProps<{
    allow?: boolean
}>();
</script>
